<template>
  <div>
    <!--    顶部按钮-->
    <div class="app-container">
      <div style="height: 30px">
        <!-- lr0014 -->
        <!-- <vxe-button v-if="domain === 'dealer'" status="primary" v-auth="`ACTIVITYAPPLY`" @click="signActNew()">活动提报</vxe-button> -->
        <vxe-button status="primary" v-auth="`EXPORT`" @click="export2Excel">导出</vxe-button>
        <vxe-button status="primary" v-auth="`BATCHAPPROVE`" @click="batchDialogVisible = true">批量审批</vxe-button>
        <vxe-button type="warning" v-auth="`ASSIGN`" @click="handleTransfer">指派</vxe-button>
        <div style="float: right; color: #848484; display: flex; line-height: 28px">
          <div v-if="!showFilter" style="float: right;display:flex">
            <a-select
              v-model="queryCondition.regionIds"
              placeholder="请选择经理部"
              mode="multiple"
              :maxTagCount="2"
              :filter-option="false"
              style="margin-right: 1rem;width:240px"
            >
              <a-select-option
                v-for="item in sectorList"
                :key="item.sectorId"
                :value="item.sectorId"
              >
                {{ item.sectorName }}
              </a-select-option>
            </a-select>
            <a-input v-model="queryCondition.applyNameOrCode" placeholder="请输入提报名称/提报编码" clearable style="width: 200px; margin-right: 1rem; height:28px" @keyup.enter.native="queryByPage(1)" />
          </div>
          <div>
            <vxe-button v-if="!showFilter" status="primary"  @click="queryByPage(1)">搜索</vxe-button>
            <vxe-button v-if="!showFilter"  class="filter-search-item" @click="resetForm(1)">重置</vxe-button>
            <vxe-button type="warning" @click="cb">
              {{ showFilter ? '收起' : '筛选' }}
            </vxe-button>
          </div>
        </div>
      </div>
      <!--    筛选拓展-->
      <div style="margin-top: 20px">
        <el-collapse-transition>
          <div v-show="showFilter">
            <SiftReimburse :data.sync="queryCondition" sift-type="apply" :sector-list="sectorList" />
            <div slot="footer" style="text-align: center; padding-bottom: 10px;margin-bottom: 10px;">
              <vxe-button type="info"  @click="resetForm(1)">重置</vxe-button>
              <vxe-button status="primary" @click="queryByPage(1)">搜索</vxe-button>
            </div>
          </div>
        </el-collapse-transition>
      </div>
      <!--提报列表-->
      <vxe-toolbar ref="toolbarRef" custom style="height:39px;margin-top:-10px;background: #F3F4F7;" />
      <vxe-table
        id="toolbar_signindex"
        ref="xTable"
        v-loading="listLoading"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        border
        align="center"
        show-header-overflow
        show-overflow
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        :custom-config="{storage: true, checkMethod: checkColumnMethod}"
        :scroll-y="{ enabled: false }"
        :row-config="{ isCurrent: true, isHover: true }"
        :data="tableData"
        @cell-dblclick="cellClickEvent"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column :visible="false" title="id" field="id" width="100" />
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <!-- <vxe-column title="申请月份" field="actMonth" width="100" /> -->
        <vxe-column :visible="false" title="活动计划编码" field="planCode" width="120" />
        <vxe-column title="活动提报编码" field="planApplyCode" width="120" />
        <vxe-column title="经理部名称" field="regionName" width="120" />
        <vxe-column :visible="false" title="经销商名称" field="dealerName" width="200" />
        <vxe-column title="经销商名称" field="dealerShortName" width="200" />
        <vxe-column title="申请人" field="createUserName" width="100" />
        <vxe-column title="活动提报名称" field="planApplyName" width="150" />
        <!-- <vxe-column :visible="false" field="applyOrderId" title="提报流程实例id" />
        <vxe-column :visible="false" field="applyHistOrderId" title="历史提报流程实例id" /> -->
        <vxe-column title="预算类型" field="budgetTypeName" width="120" />
        <vxe-column title="一级来源" field="oneLevelName" width="120" />
        <vxe-column title="二级来源" field="twoLevelName" width="120" />
        <vxe-column title="三级来源" field="threeLevelName" width="120" />
        <!-- <vxe-column title="四级来源" field="fourLevelName" width="140" />
        <vxe-column title="五级来源" field="fiveLevelName" width="140" /> -->
        <vxe-column title="计划开始时间" field="planStartTime" width="120">
          <template #default="{ row }">
            <span>{{ row.planStartTime | dateFormat("yyyy-MM-dd") }}</span>
          </template>
        </vxe-column>
        <vxe-column title="计划结束时间" field="planEndTime" width="120">
          <template #default="{ row }">
            <span>{{ row.planEndTime | dateFormat("yyyy-MM-dd") }}</span>
          </template>
        </vxe-column>
        <vxe-column :visible="false" title="提报时间" field="applyTime" width="160" />
        <vxe-column title="发起时间" field="applyFlowStart" width="160" />
        <vxe-column title="活动预算(元)" field="totalCost" width="120" >
          <template #default="{ row }">
            {{ row.totalCost | toThousandNumFilter }}
          </template>
        </vxe-column>
        <vxe-column title="品系" field="strainsNameList" width="200" />
        <vxe-column title="车型代码" field="vehicleCodeList" width="200" />
        <vxe-column title="提报审批金额（元）" field="approveApplyCost" width="130" >
          <template #default="{ row }">
            <span v-if="row.approveApplyCost">{{ row.approveApplyCost | toThousandNumFilter }}</span>
          </template>
        </vxe-column>
        <!-- <vxe-column title="集客目标" field="customerTarget" width="100" />
        <vxe-column title="订单目标" field="orderTarget" width="100" />
        <vxe-column title="实际集客" field="customerActual" width="100" />
        <vxe-column title="实际订单" field="orderActual" width="100" />
        <vxe-column title="交车数" field="deliveryTotal" width="120" /> -->
        <!-- <vxe-column title="提报类型" field="itemType" width="100">
          <template #default="{ row }">
            <span v-if="row.itemType === '0'">正常</span>
            <span v-else>追加</span>
          </template>
        </vxe-column> -->
        <vxe-column title="当前审批节点" field="applyNode" width="160" />
        <vxe-column title="当前节点审批人" field="applyAuditorNames" width="160" />
        <vxe-column :visible="false" title="当前节点审批人ids" field="applyAuditorIds" width="160" />
        <vxe-column field="name" title="集客二维码" width="190">
          <template #default="{ row }">
            <div class="handle-box">
              <!-- <a-button type="link" @click="downloadImage(handleQrView(row.planApplyCode,'1'),row.planApplyName + ' || ' + row.planApplyCode + '二维码')">
                下载
              </a-button> -->
              <a-button type="link" @click="downloadImage(row.planApplyCode,row.planApplyCode + '二维码')">
                下载
              </a-button>
            </div>
          </template>
        </vxe-column>
        <vxe-column title="提报状态" field="applyStatus" width="120">
          <template #default="{ row }">
            <span v-if="row.applyStatus === '0'">填报中</span>
            <span v-if="row.applyStatus === '1'">审批中</span>
            <span v-if="row.applyStatus === '2'">审批通过</span>
            <span v-if="row.applyStatus === '3'">已驳回</span>
            <span v-if="row.applyStatus === '4'">不通过</span>
            <span v-if="row.applyStatus === '5'">调整中</span>
          </template>
        </vxe-column>
        <vxe-column field="address" title="操作" width="380" fixed="right" align="center">
          <template #default="{ row }">
            <div class="handle-box">
              <a-button type="link" v-if="+row.applyStatus != 0" status="primary" @click="viewApproveDetail(row)">审核流程</a-button>
              <a-button type="link" status="primary" v-auth="`VIEW`" @click="queryRow(row)">详情</a-button>
              <a-button
                v-if="domain === 'dealer' && (+row.applyStatus == 0 || +row.applyStatus == 3)"
                status="primary"
                type="link"
                @click="updateRow(row)"
                v-auth="`UPDATE`"
              >修改</a-button>
              <a-button
                v-if="(domain === 'dealer') && (row.applyStatus === '0' || row.applyStatus === '3')"
                status="primary"
                type="link"
                @click="startApprove(row)"
                v-auth="`PROCESS`"
              >发起审批</a-button>
              <a-button
                v-if="domain === 'dealer' && (row.applyStatus === '0' || row.applyStatus === '3')"
                status="primary"
                type="link"
                @click="deleteRow(row)"
                v-auth="`DELETE`"
              >删除</a-button>
              <!-- <a-button
                v-if="row.applyStatus === '2' || row.applyStatus === '5'"
                status="primary"
                type="link"
                @click="editDate(row)"
              >调整时间</a-button> -->
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        v-show="!listLoading"
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />

      <vxe-modal v-model="showDetails" title="查看详情" width="600" height="400" :mask="false" :lock-view="false" resize>
        <template #default>
          <vxe-table
            border="inner"
            auto-resize
            show-overflow
            height="auto"
            :row-config="{isHover: true}"
            :show-header="false"
            :sync-resize="showDetails"
            :data="detailData"
          >
            <vxe-column field="label" width="40%" />
            <vxe-column field="value" />
          </vxe-table>
        </template>
      </vxe-modal>

      <a-modal
        title="活动提报"
        class="demo-addForm"
        :visible.sync="addSignInVisibleOne"
        width="70%"
        @close="handleClose"
        @cancel="addSignInVisibleOne=false"
        :footer="false"
      >
        <SiftActivity :data="addCondition" :show="false" />
        <div style="display: flex; justify-content: center; margin-bottom: 10px;">
          <vxe-button size="small" status="primary"  @click="getActPlans(1)">搜索</vxe-button>
          <vxe-button size="small" class="filter-search-item" @click="resetForm(2)">重置</vxe-button>
        </div>
        <vxe-table
          ref="xRole"
          border
          show-header-overflow
          show-overflow
          :column-config="{ resizable: true }"
          stripe
          round
          :loading="addLoading"
          max-height="370"
          align="center"
          :scroll-y="{ enabled: false }"
          :data="actPlanList"
          :reserve="true"
          :row-config="{ isCurrent: true, isHover: true }"
          :radio-config="{ strict: false, labelField: 'name', trigger: 'row', isCurrent: true, isHover: true }"
        >
          <vxe-column type="checkbox" width="60" align="center" />
          <vxe-column type="seq" title="序号" width="60" align="center" />
          <vxe-column field="actName" title="活动名称" width="160" />
          <vxe-column field="planCode" title="活动计划编码" width="160" />
          <vxe-column field="releaseTime" title="发布时间" width="150" />
          <vxe-column field="planStartTime" title="计划开始时间" width="120" />
          <vxe-column field="planEndTime" title="计划结束时间" width="120" />
          <vxe-column field="oneLevelName" title="一级来源" width="160" />
          <vxe-column field="twoLevelName" title="二级来源" width="160" />
          <vxe-column field="threeLevelName" title="三级来源" width="160" />
          <!-- <vxe-column field="fourLevelName" title="四级来源" width="160" />
          <vxe-column field="fiveLevelName" title="五级来源" width="160" /> -->
          <vxe-column field="budgetTypeName" title="预算类型" width="160" />
          <vxe-column field="createTime" title="创建时间" width="160" />
          <vxe-column field="createUserName" title="创建人" width="160" />
          <vxe-column field="feeLimit" title="费用额度(元)" width="160" align="right">
            <template #default="{ row }">
              {{ row.feeLimit | toThousandNumFilter }}
            </template>
          </vxe-column>
          <vxe-column field="writeRate" title="核销比例(%)" width="120" />
          <vxe-column field="executeFreq" title="执行频次" width="120" />
          <vxe-column field="remainFreq" title="剩余执行频次" width="120" />
          <vxe-column field="customerTarget" title="集客目标" width="120" />
          <vxe-column field="orderTarget" title="订单目标" width="120" />
          <vxe-column field="executeNums" title="执行数量" width="120" />
          <vxe-column field="closeTime" title="关闭时间" width="130" />
          <vxe-column field="remarks" title="活动其他说明" width="160" />
          <vxe-column field="writeOffRules" title="核销规则" width="160" />
          <vxe-column field="writeOffMaterial" title="核销材料说明" width="160" />
          <vxe-column field="writeOffOther" title="核销其他说明" width="160" />
          <vxe-column title="操作" width="150" fixed="right" align="center">
            <template #default="{ row }">
              <div class="handle-box">
                <vxe-button size="small" status="primary"  @click="signSubmit(row, 1)">追加</vxe-button>
                <vxe-button size="small" status="primary"  @click="signSubmit(row, 0)">提报</vxe-button>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
        <vxe-pager
          :loading="listLoading"
          :current-page="addTablePage.current"
          :page-size="addTablePage.size"
          :total="addTablePage.total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
          @page-change="handleAddPageChange"
        />
      </a-modal>
      <a-modal title="审批信息" :visible.sync="transdialogVisible" width="40%" @cancel="transdialogVisible=false">
        <div class="demo-input-suffix" style="padding-bottom: 20px;">
          转派人：
          <el-input v-model="operatorUser" placeholder="请选择转派的用户" style="width:35%" @focus="chooseUser" />
          <!-- <el-input v-model="operatorUser" placeholder="请选择转派的用户" style="width:35%" @click="chooseUser" readonly /> -->
        </div>
        <el-input
          v-model="approveMsg"
          type="textarea"
          placeholder="请输入审批意见"
          maxlength="300"
          show-word-limit
        />
        <span slot="footer" class="dialog-footer">
          <vxe-button :loading="TransferApproveBtnLoading" status="primary" @click="transferApprove()">确定</vxe-button>
          <vxe-button @click="transdialogVisible = false">取 消</vxe-button>
        </span></a-modal>
    </div>
    <!-- 导出对话框 -->
    <a-modal title="选择导出项" :visible.sync="dialogVisible" width="30%" @cancel="dialogVisible=false">
      <a-radio-group v-model="ExportType" style="margin-bottom: 20px;">
        <a-radio :value="0">基础数据</a-radio>
        <a-radio :value="1">详细数据</a-radio>
      </a-radio-group>
      <a-radio-group v-model="ExportItem">
        <a-radio :value="0">导出全部</a-radio>
        <a-radio :value="1">导出当前页</a-radio>
        <a-radio :value="2" :disabled="disabled">导出已选择项</a-radio>
      </a-radio-group>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="dialogVisible = false">取 消</vxe-button>
        <vxe-button status="primary" :loading="outExcelButtonLocading" @click="outExcel">确 定</vxe-button>
      </span>
    </a-modal>

    <a-modal title="审批信息" :visible.sync="taskDialogVisible" width="80%" @cancel="taskDialogVisible=false" :footer="null">
      <vxe-table
        ref="xApprove"
        border
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        :loading="approveLoading"
        max-height="370"
        align="center"
        :scroll-y="{ enabled: false }"
        :data="taskListData"
        :reserve="true"
        :row-config="{ isCurrent: true, isHover: true }"
      >
        <vxe-column type="seq" title="序号" width="60" />
        <vxe-column field="displayName" title="节点名称" />
        <vxe-column field="operatorName" title="审批人" />
        <vxe-column field="operateType" title="操作类型" />
        <!--<vxe-column field="amounts" title="申请金额" align="right">
          <template #default="{ row }">
            <span v-if="row.amounts">
              {{ row.amounts | toThousandNumFilter }}
            </span>
          </template>
        </vxe-column>-->
        <vxe-column field="approveCost" title="审核金额" >
          <template #default="{ row }">
            <span v-if="row.approveCost">
              {{ row.approveCost | toThousandNumFilter }}
            </span>
          </template>
        </vxe-column>
        <vxe-column field="approveMsg" title="审批意见" />
        <vxe-column field="finishTime" title="处理时间" />
      </vxe-table>
    </a-modal>

    <a-modal title="审批信息" :visible.sync="appdialogVisible" width="40%" @cancel="appdialogVisible=false">
      <el-input
        v-model="approveMsg"
        type="textarea"
        placeholder="请输入审批意见"
        maxlength="300"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button status="primary" :loading="approveBtnLoading" @click="approve()">发起审批</vxe-button>
        <vxe-button @click="appdialogVisible = false">取 消</vxe-button>
      </span>
    </a-modal>

    <a-modal title="批量审批信息" :visible.sync="batchDialogVisible" width="40%" @cancel="batchDialogVisible=false">
      <el-input
        v-model="batchApproveMsg"
        type="textarea"
        placeholder="请输入审批意见"
        maxlength="300"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button status="primary" :loading="approveBtnLoading" @click="approveBatch()">同意</vxe-button>
        <vxe-button @click="batchDialogVisible = false">取 消</vxe-button>
      </span>
    </a-modal>

    <el-dialog title="选择用户" :visible.sync="userDialogVisible" width="75%">
      <div style="margin-bottom: 20px">
        <el-input v-model="userName" placeholder="输入用户名称" clearable :style="{ width: '80%' }" @change="handleFilter" />
        <vxe-button status="primary"  class="filter-search-item" style="float: right" @click="handleFilter">搜索</vxe-button>
      </div>
      <vxe-table
        ref="Xuser"
        border
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        :loading="userLoading"
        max-height="350"
        align="center"
        :scroll-y="{ enabled: false }"
        :data="userLists"
        :reserve="true"
        :row-config="{ isCurrent: true, isHover: true }"
        :radio-config="{ strict: false, labelField: 'seq', trigger: 'row', isCurrent: true, isHover: true }"
      >
        <vxe-column type="radio" width="60" />
        <vxe-column :visible="false" field="id" title="用户id" />
        <vxe-column type="seq" title="序号" width="60" />
        <vxe-column field="name" title="用户名称" width="110" />
        <!-- <vxe-column field="roleNames" title="角色" /> -->
        <vxe-column field="department" title="所属组织结构" />
      </vxe-table>
      <vxe-pager
        :loading="userLoading"
        :current-page="userTablePage.currentPage"
        :page-size="userTablePage.pageSize"
        :total="userTablePage.totalResult"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="handlePageChange"
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="userDialogVisible = false">取 消</vxe-button>
        <vxe-button status="primary" @click="handleChooseUser()">确 定</vxe-button>
      </span>
    </el-dialog>

    <!-- 发起对话框 -->
    <a-modal title="发起流程" :visible.sync="approveDialog" width="25%" @cancel="approveDialog=false">
      <div class="demo-input-suffix">
        意见栏：
        <el-input v-model="approveMsg" placeholder="请输入内容" />
      </div>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="approveDialog = false">取 消</vxe-button>
        <vxe-button status="primary" @click="confirmStart">确 定</vxe-button>
      </span>
    </a-modal>
    <!-- 流程图对话框 -->
    <a-modal title="提报审核流程" :visible.sync="checkFlowShow" width="80%" @cancel="checkFlowShow = false">
      <checkFlow :data="budgetData" />
    </a-modal>
  </div>
</template>

<script>
import { findActsByDealer, findPlanApplyList, saveApproveInfo, exportActPlanApply, exportActPlanApply2, deleteActApply, approveApplyBatch, getActApplyFileNum } from '@/api/actPlan'
import { http } from '@/api/activityCheck'
import { findTaskInfos, findDisTaskInfos, transfer } from '@/api/wf_process'
import { approveStart, approveRestart, download } from '@/api/wf_process.js'
import { findSectorList } from '@/api/base-data'
import { findList } from '@/api/user'
import SiftReimburse from './components/SiftReimburse.vue'
import checkFlow from './components/checkFlow.vue'
import SiftActivity from './components/SiftActivity.vue'
// import { mapGetters } from 'vuex'
// import permission from '@/directive/permission'
// import store from '@/store'
import { dateFormat } from '@/utils/DateUtils'

// const url = process.env.VUE_APP_BASE_API + 'CUSTOMER-SERVE/image/download'
// https://marketactivitypro-test.dflzm.com/CUSTOMER-SERVE/image/download?code=TB202411280002
const url = process.env.VUE_APP_API_BASE_URL + '/CUSTOMER-SERVE/image/download'
const defaultListQuery = {
  page: 1,
  limit: 10,
  importance: undefined,
  domain: 'center',
  title: undefined,
  type: undefined,
  conditions: [],
  sort: '+id'
}

const defaultApproveStatus = new Map([
  ['0', '填报中'],
  ['1', '审批中'],
  ['2', '审批通过'],
  ['3', '已驳回'],
  ['4', '不通过'],
  ['5', '调整中']
])

const defaultItemType = new Map([
  ['0', '正常'],
  ['1', '追加']
])

const defautFactor = {
  code: '',
  symbol: '',
  values: ''
}

const defaultQueryCondition ={
    planStatus: null, // 状态
    budgetTypeCode: null,
    planCodeOrName: null,
    oneLevelCode: null,
    twoLevelCode: null,
    threeLevelCode: null,
    regionIds:[],
    dealerIds:[]
  }

export default {
  name: 'SignIndex',
  // directives: { permission },
  components: {
    SiftReimburse,
    checkFlow,
    SiftActivity
  },
  data() {
    return {
      siftType:'apply',//查询类型：writeOff核销，apply提报
      sectorList: [],
      showDetails: false,
      detailData: [],
      checkFlowShow: false,
      budgetData: [],
      QrUrl: url,
      approveBtnLoading: false,
      queryCondition: Object.assign({}, defaultQueryCondition),
      batchDialogVisible: false,
      batchApproveMsg: '',
      disabled: true, // 打印当前页面是否选中
      ExportItem: 0,
      ExportType: 0,
      userName: '',
      operatorUser: '',
      operatorId: '',
      factor: Object.assign({}, defautFactor),
      dialogVisible: false,
      taskDialogVisible: false,
      approveLoading: false,
      appdialogVisible: false,
      taskListData: [],
      userLists: [],
      approveStatusMap: defaultApproveStatus,
      itemTypeMap: defaultItemType,
      TransferApproveBtnLoading: false,
      userLoading: false,
      listQuery: Object.assign({}, defaultListQuery),
      userTablePage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0
      },
      currentRow: {},
      outExcelButtonLocading: false,
      domain: 'dealer',
      addSignInVisibleOne: false,
      listLoading: false,
      tableData: [],
      // pagination: Object.assign({}, defaultPagination),
      dialog: {
        visiable: false,
        export: false
      },
      actPlanList: [],
      addLoading: false,
      addTablePage: {
        current: 1,
        size: 20,
        total: 0
      },
      sort: 'apply_time desc',
      approveDialog: false,
      approveMsg: '',
      approveCost: '',
      selectRow: {},
      transdialogVisible: false,
      userDialogVisible: false,
      addSort: 'release_time desc',
      addCondition: {
        planStatus: null, // 状态
        budgetTypeCode: null,
        planCodeOrName: null,
        oneLevelCode: null,
        twoLevelCode: null,
        threeLevelCode: null
      },
      showFilter: false,
      pagination: {
        current: 1,
        size: 20,
        total: 0
      },

    }
  },
  computed: {
    // ...mapGetters(['userinfo']),
    // queryCondition() {
    //   return this.$store.state.actApplyListPage.queryCondition
    // },
    // pagination() {
    //   return this.$store.state.actApplyListPage.pagination
    // },
    // showFilter() {
    //   return this.$store.state.actApplyListPage.showFilter
    // },
    // addCondition() {
    //   return this.$store.state.actPlanListPage.queryCondition
    // },
    // addTablePage() {
    //   return this.$store.state.actPlanListPage.pagination
    // }
  },
  watch: {
    appdialogVisible(val) {
      if (!val) {
        this.approveMsg = ''
        this.approveCost = ''
        this.currentRow = Object.assign({}, {})
      }
    },
    transdialogVisible(val) {
      if (!val) {
        this.operatorId = ''
        this.operatorUser = ''
        this.approveMsg = ''
        this.TransferApproveBtnLoading = false
      }
    }
  },
  mounted: function() {
    this.getSectorList()
    this.queryByPage()
    this.$nextTick(() => {
      const $table = this.$refs.xTable
      const $toolbar = this.$refs.toolbarRef
      if ($table && $toolbar) {
        $table.connect($toolbar)
      }
    })
    // const userinfo = store.getters && store.getters.userinfo

    console.log(download(),'-download-');
    
  },
  methods: {
    // 审批流程图弹窗
    async checkFlowFun(row) {
      this.budgetData = []
      try {
        const id = row.approveorder || row.approvehistorder
        if (id.length > 1) {
          this.checkFlowShow = true
          this.budgetData = await http.getApproveProcess({ approveOrderId: id }).then(v => v.data)
        } else {
          this.$message.error('未找到审核记录')
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    cellClickEvent({ row }) {
      this.detailData = [//{
    //    field: 'actMonth',
    //    title: '申请月份'
    //  },
      {
        field: 'applyStatus',
        title: '提报状态'
      },
      {
        field: 'planCode',
        title: '活动计划编码'
      },
      {
        field: 'planApplyCode',
        title: '活动提报编码'
      },
      {
        field: 'regionName',
        title: '经理部名称'
      },
      {
        field: 'dealerName',
        title: '经销商名称'
      },
      {
        field: 'planApplyName',
        title: '活动提报名称'
      },
      {
        field: 'createUserName',
        title: '申请人'
      },
      {
        field: 'planApplyName',
        title: '活动提报名称'
      },
      {
        field: 'budgetTypeName',
        title: '预算类型'
      },
      {
        field: 'oneLevelName',
        title: '一级来源'
      },
      {
        field: 'twoLevelName',
        title: '二级来源'
      },
      {
        field: 'threeLevelName',
        title: '三级来源'
      },
      // {
      //   field: 'fourLevelName',
      //   title: '四级来源'
      // },
      // {
      //   field: 'fiveLevelName',
      //   title: '五级来源'
      // },
      {
        field: 'planStartTime',
        title: '计划开始时间'
      },
      {
        field: 'planEndTime',
        title: '计划结束时间'
      },
      {
        field: 'applyFlowStart',
        title: '发起时间'
      },
      {
        field: 'totalCost',
        title: '活动预算（元）'
      },
      {
        field: 'strainsNameList',
        title: '品系'
      },
      {
        field: 'vehicleCodeList',
        title: '车型代码'
      },
      {
        field: 'approveApplyCost',
        title: '提报审批金额(元)'
      },
    //  {
    //    field: 'customerTarget',
    //    title: '集客目标'
    //  },
    //  {
    //    field: 'customerActual',
    //    title: '集客实际'
    //  },
    //  {
    //    field: 'orderActual',
    //    title: '订单实际'
    //  },
    //  {
    //    field: 'deliveryTotal',
    //    title: '交车数'
    //  },
    //  {
    //    field: 'itemType',
    //    title: '提报类型'
    //  },
    //  {
    //    field: 'applyTime',
    //    title: '提报时间'
    //  },
      {
        field: 'applyNode',
        title: '当前审批节点'
      },
      {
        field: 'applyAuditorNames',
        title: '当前审批人'
      }].map(obj => {
        if (obj.field === 'applyStatus') {
          return { label: obj.title, value: this.approveStatusMap.get(row[obj.field]) }
        }
        if (obj.field === 'itemType') {
          return { label: obj.title, value: this.itemTypeMap.get(row[obj.field]) }
        }
        return { label: obj.title, value: row[obj.field] }
      })
      this.showDetails = true
    },
    // downloadImage(imgsrc, name) { // 下载图片地址和图片名
    //   console.log(imgsrc,name,'000000');
      
    //   const image = new Image()
    //   // 解决跨域 Canvas 污染问题
    //   image.setAttribute('crossOrigin', 'anonymous')
    //   image.onload = function() {
    //     const canvas = document.createElement('canvas')
    //     canvas.width = image.width
    //     canvas.height = image.height
    //     const context = canvas.getContext('2d')
    //     context.drawImage(image, 0, 0, image.width, image.height)
    //     const url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
    //     const a = document.createElement('a') // 生成一个a元素
    //     const event = new MouseEvent('click') // 创建一个单击事件
    //     a.download = name || 'photo' // 设置图片名称
    //     a.href = url // 将生成的URL设置为a.href属性
    //     a.dispatchEvent(event) // 触发a的单击事件
    //   }
    //   image.src = imgsrc
    // },

    downloadImage(code, name) { // 下载图片地址和图片名
      console.log(code,name,'000000'); 
      download(code).then(res => {
        if (res) {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel", //将会被放入到blob中的数组内容的MIME类型
          })
          let url = URL.createObjectURL(blob) 
          const image = new Image()
          // 解决跨域 Canvas 污染问题
          image.setAttribute('crossOrigin', 'anonymous')
          image.onload = function() {
            const canvas = document.createElement('canvas')
            canvas.width = image.width
            canvas.height = image.height
            const context = canvas.getContext('2d')
            context.drawImage(image, 0, 0, image.width, image.height)
            const url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
            const a = document.createElement('a') // 生成一个a元素
            const event = new MouseEvent('click') // 创建一个单击事件
            a.download = name || 'photo' // 设置图片名称
            a.href = url // 将生成的URL设置为a.href属性
            a.dispatchEvent(event) // 触发a的单击事件
          }
          image.src = url
        }
      })
    },
    // handleQrView(code) {
    //   // return this.QrUrl + '?code=' + code
    //   return download(code)
    // },
    checkColumnMethod({ column }) {
      if (column.field === 'id' || column.field === 'applyAuditorIds') {
        return false
      }
      return true
    },
    getActPlans(e) {
      if (e) this.addTablePage.current = e
      const data = {
        page: this.addTablePage.current,
        limit: this.addTablePage.size,
        sort: this.addSort,
        ...this.addCondition
      }
      this.addLoading = true
      findActsByDealer(data).then(res => {
        if (res.code === 1) {
          this.addTablePage.total = res.data.total
          this.actPlanList = res.data.list
          this.addLoading = false
        }
      }).finally(()=> this.addLoading = false)
    },
    startApprove(row) {
      getActApplyFileNum(row.planApplyCode).then(res => {
        if (res.code === 1) {
          if (res.data === 0) {
            this.$message.warning('该活动未提交计划方案附件，请提交方案附件后重新发起审批')
            return
          }
          this.appdialogVisible = true
          this.currentRow = row
        }
      })
    },
    showBatchDialog() {
      this.batchDialogVisible = true
    },
    handlePageChange({ currentPage, pageSize }) {
      this.userTablePage.currentPage = currentPage
      this.userTablePage.pageSize = pageSize
      this.listQuery.limit = pageSize
      this.listQuery.page = currentPage
      this.findUsers()
    },
    handleTransfer() {
      if (this.$refs.xTable.selection.length !== 1) {
        this.$message.warning('请勾选一条记录')
        return
      }
      const flag = this.$refs.xTable.selection.every(item => item.applyStatus === '1')
      if (flag === false) {
        this.$message.warning('所选记录中存在不是审批中状态的记录')
        return
      }
      this.transdialogVisible = true
    },
    handleFilter() {
      this.listQuery.page = 1
      this.factor.code = 'nameOrAccount'
      this.factor.values = this.userName
      this.listQuery.conditions[0] = this.factor
      this.findUsers()
    },
    chooseUser() {
      this.userDialogVisible = true
      this.findUsers()
    },
    handleChooseUser() {
      const data = this.$refs['Xuser'].getRadioRecord()
      if (data) {
        this.operatorUser = data.name
        this.operatorId = data.id
      }
      this.userDialogVisible = false
    },
    findUsers() {
      this.userLoading = true
      findList(this.listQuery).then(res => {
        if (res.code === 1 && res.data) {
          this.userLists = res.data.list
          this.userTablePage.totalResult = res.data.total
          this.userLoading = false
        }
      })
    },
    transferApprove() {
      this.TransferApproveBtnLoading = true
      const signData = this.$refs.xTable.selection[0]
      const approveParam = {
        orderId: signData.applyOrderId,
        operator: this.operatorId,
        args: {
          amounts: signData.totalCost,
          approveMsg: this.approveMsg,
          businessCode: signData.planApplyCode,
          businessName: signData.planApplyName
        }
      }
      transfer(approveParam).then(res => {
        if (res.code === 1) {
          signData.applyNode = res.data.approveNode
          signData.applyAuditorNames = res.data.operatorInfos[0].operatorNames
          signData.applyAuditorIds = res.data.operatorInfos[0].operatorIds
          saveApproveInfo(signData).then(v => {
            if (v.code === 1) {
              // this.reload()
              this.transdialogVisible = false
              this.TransferApproveBtnLoading = false
              this.reload()
            }
          })
        }
      })
    },
    approveBatch() {
      if (this.$refs.xTable.selection.length < 1) {
        this.$message.warning('请至少勾选一条记录')
        return
      }
      let flag = this.$refs.xTable.selection.every(item => item.applyStatus === '1')
      if (flag === false) {
        this.$message.warning('所选记录中存在不是审批中状态的记录')
        return
      }
      // flag = this.$refs.xTable.selection.every(item => item.applyAuditorIds.indexOf(this.userinfo.id) != -1)
      // if (flag === false) {
      //   this.$message.warning('所选记录中存在当前节点审批人不是当前用户的记录，请检查')
      //   return
      // }
      this.$refs.xTable.selection.forEach(element => {
        element.approveMsg = this.batchApproveMsg
      })
      const data = this.$refs.xTable.selection
      this.approveBtnLoading = true
      approveApplyBatch(data).then(res => {
        if (res.code === 1) {
          this.$message.success('审批成功')
          this.approveBtnLoading = false
          this.batchDialogVisible = false
          this.reload()
        }
      })
    },
    approve() {
      //  发起审批
      this.approveCost = this.currentRow.totalCost
      if (this.approveMsg === '') {
          this.approveBtnLoading = false
          this.$message.warning('审批意见不能为空')
          // this.approveValFalse = true
          return
        }
      if (this.currentRow.applyStatus === '0') {
        this.$store.dispatch('SelectData/QuerySelect', ['actProcessMap']).then(v => {
          const obj = v.actProcessMap.find(item => item.code === this.currentRow.budgetTypeCode)
          if (!obj) {
            this.$message.error('该预算类型未配置提报审批流')
            return
          }
          const approveParam = {
            processName: obj.value,
            args: {
              amounts: this.currentRow.totalCost,
              approveMsg: this.approveMsg,
              approveCost: this.approveCost,
              businessCode: this.currentRow.planApplyCode,
              businessName: this.currentRow.planApplyName
            }
          }
          this.approveBtnLoading = true
          // 发起流程
          approveStart(approveParam).then(res => {
            if (res.code === 1) {
              this.currentRow.applyOrderId = res.data.orderId
              this.currentRow.applyNode = res.data.approveNode
              this.currentRow.applyFlowStart = dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
              this.currentRow.applyStatus = '1'
              this.currentRow.approveApplyCost = this.approveCost
              this.currentRow.applyFlowStart = dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
              this.currentRow.applyAuditorNames = res.data.operatorInfos[0].operatorNames
              this.currentRow.applyAuditorIds = res.data.operatorInfos[0].operatorIds
              saveApproveInfo(this.currentRow).then(v => {
                if (v.code === 1) {
                  this.$message.success('流程发起成功')
                  this.approveBtnLoading = false
                  this.appdialogVisible = false
                  this.reload()
                }
              })
            }
          })
        })
      } else if (this.currentRow.applyStatus === '3') {
        // 已驳回重新发起流程
        const approveParam = {
          orderId: this.currentRow.applyOrderId,
          processName: this.currentRow.activityApplyProcessName,  
          args: {
            amounts: this.currentRow.totalCost,
            approveCost: this.approveCost,
            approveMsg: this.approveMsg,
            businessCode: this.currentRow.planApplyCode,
            businessName: this.currentRow.planApplyName
          }
        }
        this.approveBtnLoading = true
        approveRestart(approveParam).then(res => {
          if (res.code === 1) {
            this.currentRow.applyStatus = '1'
            // this.currentRow.applyFlowStart = dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
            this.currentRow.applyNode = res.data.approveNode
            this.currentRow.approveApplyCost = this.approveCost
            this.currentRow.applyAuditorNames = res.data.operatorInfos[0].operatorNames
            this.currentRow.applyAuditorIds = res.data.operatorInfos[0].operatorIds

            saveApproveInfo(this.currentRow).then(v => {
              if (v.code === 1) {
                this.$message.success('流程发起成功')
                this.approveBtnLoading = false
                this.appdialogVisible = false
                this.reload()
              }
            })
          }
        })
      }
    },
    viewApproveDetail(row) {
      this.taskDialogVisible = true
      this.approveLoading = true
      const param = {
        orderId: row.applyOrderId || row.applyHistOrderId
      }
      if (row.applyStatus === '4') {
        findDisTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.taskListData = res.data
            this.approveLoading = false
          }
        })
      } else {
        findTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.taskListData = res.data
            this.taskListData.forEach(item => {
              if (!item.his) {
                item.operatorName = row.applyAuditorNames
                item.finishTime = '正在处理'
              }
            })
            this.approveLoading = false
          }
        })
      }
    },
    signSubmit(row, type) {
      // 获取当前日期
      const currentDate = new Date()
      const closeDate = new Date(row.closeTime)
      // 将时间部分设置为相同，这里将时间部分都设置为 00:00:00
      currentDate.setHours(0, 0, 0, 0)
      closeDate.setHours(0, 0, 0, 0)

      if (currentDate > closeDate && row.closeTime !== null) {
        this.$message.warning('活动计划已关闭，' + '当前时间' + currentDate.Format('yyyy-MM-DD') + '已超过该活动计划关闭时间' + closeDate.Format('yyyy-MM-DD'))
        return
      }
      this.addSignInVisibleOne = false
      this.$router.push({ path: `signActivity/${row.id}/${type}` })
    },
    handleAddPageChange({ currentPage, pageSize }) {
      this.addTablePage.current = currentPage
      pageSize !== this.addTablePage.size && (this.addTablePage.current = 1)
      this.addTablePage.size = pageSize
      this.getActPlans()
    },
    // 获取大区
    getSectorList() {
      findSectorList().then(res => {
        if (res.code === 1 && res.data) {
          this.sectorList = res.data
        }
      })
    },
    // 重置筛选
    resetForm(e) {
      if (e === 1) {
        // 使用 Vuex 模块中的默认搜索条件重置
        // this.$store.commit('actApplyListPage/resetQueryCondition')
      this.queryCondition = { ...defaultQueryCondition }
      this.pagination = {
        current: 1,
        size: 20,
        total: 0
      }
        this.queryByPage()
      } else {
        this.queryCondition = { ...defaultQueryCondition }
        this.pagination = {
          current: 1,
          size: 20,
          total: 0
        }
        this.addCondition = {
          planStatus: null, // 状态
          budgetTypeCode: null,
          planCodeOrName: null,
          oneLevelCode: null,
          twoLevelCode: null,
          threeLevelCode: null
        }
        // this.$store.commit('actPlanListPage/resetQueryCondition')
        this.getActPlans()
      }
    },
    queryRow(row) {
      this.$router.push({
        path: `signDetails/${row.id}`
      })
    },
    updateRow(row) {
      this.$router.push({
        path: `editSignActivity/${row.id}`
      })
    },
    editDate(row) {
      if (this.domain === 'dealer' && row.applyStatus === '2') {
        this.$router.push({
          path: `editSignActivityDate/${row.id}/edit`
        })
      }
      if (row.applyStatus === '5') {
        this.$router.push({
          path: `editSignActivityDate/${row.id}/approve`
        })
      }
      if (this.domain === 'center' && row.applyStatus === '2') {
        this.$router.push({
          path: `editSignActivityDate/${row.id}/approve`
        })
      }
    },
    deleteRow(row) {
      this.$confirm({
        title: '提示',
        content: '确定删除该活动？',
        onOk:() => {
          deleteActApply(row.id).then(res => {
            if (res.code === 1) {
              this.$message.success('删除成功')
              this.queryByPage(1)
            } else {
              this.$message.error(res.message)
            }
          })
        },
        onCancel:() => {
          this.$message.info('已取消删除')
        },
      });
    },
    signActNew() {
      this.addSignInVisibleOne = true
      this.getActPlans()
    },
    handleClose() {
      this.actPlanList = []
      this.resetForm(2)
    },
    linkToActivity(planCode) {
      if (planCode) {
        if (this.domain === 'dealer') {
          this.$router.push({ name: 'ApplyActivityList', params: { planCode: planCode }})
        } else {
          this.$router.push({ name: 'MaintainActivity', params: { planCode: planCode }})
        }
      }
    },
    approveStart(row) {
      // if (row.marketactid) {
      //   const param = {
      //     businessId: row.marketactid
      //   }
      //   marketApproveStart(param).then(res => {
      //     if (res.code === 1) {
      //       this.$message.success('流程发起成功')
      //     } else {
      //       this.$message.error('流程发起失败')
      //     }
      //   })
      // }
      this.selectRow = row
      this.approveDialog = true
    },
    confirmStart() {
      this.approveDialog = false
    },
    cb() {
      // this.$store.commit('actApplyListPage/updateShowFilter', !this.showFilter)
    this.showFilter = !this.showFilter
    },
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      pageSize !== this.pagination.size && (this.pagination.current = 1)
      this.pagination.size = pageSize
      this.queryByPage()
    },
    export2Excel() {
      this.ExportItem = 0
      this.disabled = this.$refs.xTable.getCheckboxRecords().length < 1
      this.dialogVisible = true
    },
    async outExcel() {
      this.outExcelButtonLocading = true
      let param = {}
      if (this.ExportItem == 0) {
        if (this.pagination.total > 10000) {
          this.$message.warning('导入' + this.pagination.total + '条，过程可能持续数分钟。')
        }
        param = {
          page: 1,
          limit: this.pagination.total,
          sort: this.sort,
          ...this.queryCondition,
          siftType: this.siftType
        }
      } else if (this.ExportItem == 1) {
        param = {
          page: this.pagination.current,
          limit: this.pagination.size,
          sort: this.sort,
          ...this.queryCondition,
          siftType: this.siftType
        }
      } else if (this.ExportItem == 2) {
        const idList = []
        this.$refs.xTable.getCheckboxRecords().forEach(item => {
          idList.push(item.id)
        })
        param = {
          page: 1,
          limit: this.pagination.size,
          ids: idList,
          sort: this.sort,
          ...this.queryCondition
        }
      }
      if (this.ExportType === 0) {
        exportActPlanApply2(param).then(val => {
          this.$exportExcelData(val, `活动提报列表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
          this.dialogVisible = false
          this.outExcelButtonLocading = false
        })
      } else {
        exportActPlanApply(param).then(val => {
          this.$exportExcelData(val, `活动提报列表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
          this.dialogVisible = false
          this.outExcelButtonLocading = false
        })
      }
    },
    queryByPage(e) {
      if (e) this.pagination.current = e

      // 保存搜索条件到store
      this.$store.commit('actApplyListPage/updatePagination', this.pagination)
      this.$store.commit('actApplyListPage/updateQueryCondition', this.queryCondition)

      this.listLoading = true
      var data = {
        page: this.pagination.current,
        limit: this.pagination.size,
        ...this.queryCondition,
        sort: this.sort,
        siftType: this.siftType // 查询类型：writeOff核销，apply提报
      }
      findPlanApplyList(data).then(res => {
        if (res.code === 1) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          this.listLoading = false
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => this.listLoading = false)
    },
    ReturnFun() {
      this.$deleteBeforeRouter(this)
      this.$router.push('/market_activity/center/signIndex')
    }
  }
}
</script>
<style lang="less" scoped>
.el-input__inner {
  height: 31px !important;
}
.operate {
  display: flex;
  justify-content: space-around;
}
.act-item {
  width: 300px;
  text-align: right;
  margin-bottom: 5px;
}
/deep/ .ant-select-selection--multiple  {
  height: 28px !important;
  min-height: 28px !important;
  line-height: 28px !important;
}
</style>
